import { render, staticRenderFns } from "./seat-post.vue?vue&type=template&id=1bfacd02&scoped=true"
import script from "./seat-post.vue?vue&type=script&lang=js"
export * from "./seat-post.vue?vue&type=script&lang=js"
import style0 from "./seat-post.vue?vue&type=style&index=0&id=1bfacd02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfacd02",
  null
  
)

export default component.exports